// Load SASS to be pre-processed by WebPack
import "./scss/style";
import { CountUp } from '../js/countUp.min.js';
import { Odometer } from '../js/odometer.min.js';

import Worker from './service.worker.js'; // Note the .worker.js extension or similar




// Global state variables
window.NAV_OPEN = false;
window.MODAL_OPEN = false;
window.IS_TOUCH = false;
window.dataLayer = window.dataLayer || [];

(function($){

    $.fn.countup = function (params) {
        // make sure dependency is present
        if (typeof CountUp !== 'function') {
          console.error('countUp.js is a required dependency of countUp-jquery.js.');
          return;
        }
    
        var defaults = {
          startVal: 0,
          decimalPlaces: 0,
          duration: 2,
        };
    
        if (typeof params === 'number') {
          defaults.endVal = params;
        }
        else if (typeof params === 'object') {
          $.extend(defaults, params);
        }
        else {
          console.error('countUp-jquery requires its argument to be either an object or number');
          return;
        }
    
        this.each(function (i, elem) {
    
          
          let end_point = parseInt($(this).data('end-point'), 10);
          
    
    
          var countUp = new CountUp($(elem), end_point, defaults);
          
    
          if (!countUp.error) {
            countUp.start();
          } else {
  
          }
    
          countUp.start();
    
        });
    
        return this;
      };




    function removeClassPrefix(prefix) {
        this.each(function(i, el) {
            var classes = el.className.split(" ").filter(function(c) {
                return c.lastIndexOf(prefix, 0) !== 0;
            });
            el.className = $.trim(classes.join(" "));
        });
        return this;
    };
  
    async function digestMessage(message) {
        
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array

        const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8); // hash the message
    
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join(""); // convert bytes to hex string
        
        return hashHex;
    }
  

  // Container JS object to contain all functions and keep things neat
  const app = {

    ////HELPER FUNCTIONS


    // PREVENT DEFAULT HANDLER
    preventDefault: function(e) {
        e = e || window.event;
        if (e.preventDefault) {
          e.preventDefault();
        }
        e.returnValue = false;
    },
    // PREVENT SCROLL KEYS
    // left: 37, up: 38, right: 39, down: 40,
    // (Source: http://stackoverflow.com/a/4770179)
    keydown: function(e) {
        var keys = [33,34,35,36,38,40];
        for (var i = keys.length; i--;) {
            if (e.keyCode === keys[i]) {
                app.preventDefault(e);
                return;
            }
        }
    },
    // PREVENT MOUSE WHEEL
    wheel: function(event) {
event.preventDefault();
        event.stopPropagation();
        return false;
    },
    // DISABLE SCROLL
    disable_scroll: function() {
        const scrollY = window.scrollY;
        document.body.style.top = `-${scrollY}px`;
        
        if (document.addEventListener) {
            document.addEventListener('wheel', app.wheel, false);
            document.addEventListener('mousewheel', app.wheel, false);
            document.addEventListener('DOMMouseScroll', app.wheel, false);
        }
        else {
            document.attachEvent('onmousewheel', app.wheel);
        }
        document.onmousewheel = document.onmousewheel = app.wheel;
        document.onkeydown = app.keydown;
        
        let x = window.pageXOffset || document.documentElement.scrollLeft;
        let y = window.pageYOffset || document.documentElement.scrollTop;
        window.onscroll = function() {
            window.scrollTo(x, y);
        };
        // document.body.style.overflow = 'hidden'; // CSS
        app.disable_scroll_mobile();
    },
    // ENABLE SCROLL
    enable_scroll: function() {
        const scrollY = document.body.style.top;
        
        if (document.removeEventListener) {
            document.removeEventListener('wheel', app.wheel, false);
            document.removeEventListener('mousewheel', app.wheel, false);
            document.removeEventListener('DOMMouseScroll', app.wheel, false);
        }
        document.onmousewheel = document.onmousewheel = document.onkeydown = null;
        window.onscroll = function() {};
        // document.body.style.overflow = 'auto'; // CSS
        app.enable_scroll_mobile();
        
        document.body.style.top = '';
        
        if (scrollY) {
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    },

    // MOBILE
    disable_scroll_mobile: function (){
        document.addEventListener('touchmove', app.preventDefault, false);
    },
    enable_scroll_mobile: function(){
        document.removeEventListener('touchmove', app.preventDefault, false);
    },

    numberWithCommas: function (x) {
        return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    getUrlParameter: function (sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
        
        let filter_array = [];
        for (i = 0; i < sURLVariables.length; i++) {
          
            sParameterName = sURLVariables[i].split('=');
          


            if (sParameterName[0] === sParam) {
              filter_array.push(sParameterName[1])
            }
        }
        
        return filter_array;
    },


    
    //document.load scripts
    onReady: function () {
      
           // Get the current URL
      




      $('.header-nav-toggle').on('click', function(){

        if(!$(this).hasClass('active')) {
        
          app.toggleNav(true);
           
          

        } else {
        
          app.toggleNav(false);
        }
        
      });
      
      // Event listener for clicks on scroller elements
      $(document).on('click', 'a[href*="#"]:not([href="#"])', function (e) {
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          e.preventDefault();
            
            

          var target = e.target.hash.replace(/^#/, "");
         
          

          if (this.parentElement.parentElement.classList.contains("nav-menu") || this.parentElement.parentElement.classList.contains("menu")) {
            app.toggleNav(false);
          }
          if (this.classList.contains("modal--trigger")) {
            if(!$(this).hasClass('active')) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
            app.toggleModal(target, this);
          } else {
            app.scrollTo(target);
          } 
        }
      }); 

      $('a.back-to-top[href="#"]').click(function (e) {
        
        $("html, body").animate({
          scrollTop: 0
        },1000)


      })
      




    },
    stickySessionUTMS: function() {


        //I THINK WE SHOULD MOVE THIS TO A SESSION STORAGE THING THAT FILLS FIELD ON FORM SUBMIT 
        //ON THE OTHER HAND THIS ALLOWS FOR MORE DETAILSED USER TRACKING THROUGH THE SITE AS IT APPENDS THE UTMS TO EACH STEP IN THEIR JOURNEY



        if (window.location.search.includes('utm_')) {

            document.addEventListener('click', function(event){
        
                // get the nearest anchor tag to where the user clicked (in case they clicked on something inside the anchor tag like an <img> or <span>
                let aTag = event.target.closest('a');
                


                if (aTag !== null) {

                    if (aTag.getAttribute("href").charAt(0) !== "#") {

                        let urlParams = new URLSearchParams(window.location.search);
                        let aParams = new URLSearchParams(aTag.search);
            
                        // update the <a> tag's params with UTM params
                        for (let [key, value] of urlParams.entries()) {
            
                            // skip duplicates and only add new params that belong to UTM
                            if (! aParams.has(key) && key.includes('utm_')) {
                                aParams.append(key, value);
                            }
                        }
            
                        // reset the anchor's URL with all the query params added
                        aTag.href = aTag.href.split('?')[0] + '?' + aParams.toString();
                    }
                }
        
            });
        
        }
    },
    lenisSmoothScrollInit: function() {
        const lenis = new Lenis()

        lenis.on('scroll', (e) => {
          lurp: 0.05
        })
        
        function raf(time) {
        lenis.raf(time)
        requestAnimationFrame(raf)
        }
        
        requestAnimationFrame(raf);
    },
    

    set100vh: function() {
      let root = document.documentElement;
      let vh100 = window.innerHeight;
      
     

      vh100 = $.trim(vh100);

      vh100 = parseInt(vh100);
   
		if($(window).width() < 992) {
     
      root.style.setProperty('--100vh', vh100 + 'px');
    } else {
      root.style.setProperty('--100vh', '100vh');
    }
      
      
    },
    toggleNav: function(trigger){      
      /* Open or close the nav depending on the state of the NAV_OPEN var. Allows you to 
       * re-use this function to close nav when menu links are clicked.
       */

      if(trigger === false){
        
        $("#header, .header-nav-toggle, .header-navigation, .header-navigation-secondary").removeClass("active");
        $("#header").removeClass("pointer-events-active");
        $('.menu-item-has-children').removeClass('active');
        $('ul.sub-menu').removeClass('active');
        $('ul.menu').removeClass('active');
        
        setTimeout(function(){
            $('body').removeClass('no-scroll');
            $('body').removeClass('menu-active');
            app.enable_scroll();
        }, 750);

      } else if(trigger === true) {

        app.disable_scroll();

        $('body').addClass('menu-active');
        $('body').addClass('no-scroll');
        $("#header, .header-nav-toggle, .header-navigation, .header-navigation-secondary").addClass("active"); 
        setTimeout(function(){
            $("#header").addClass("pointer-events-active");
        }, 1500)
        //bool with cookie
        // $(".header-navigation brand-pattern").addClass("active");  
        
      }
    },

    initModals: function() {


      $(".modal").each(function(){


        let target = $(this).attr('id')+'-activated';
 
        
        let modalCookieValue = Cookies.get(target);

    

        if (modalCookieValue != true && modalCookieValue != 'true') {

        

          if($(this).data('auto') === true) {

            let delay = parseInt($(this).data('auto-delay'), 10);
            
            let modal = $(this);
            setTimeout(function(){

                app.disable_scroll();
                $('body').addClass('modal-active');
                $('body').addClass('no-scroll');
                modal.addClass('active');
                //Cookies.set(target, true);
             

            }, delay);
  
  
          }
        }

        

      })

     
    },

    toggleModal: function (targetModal, clickElem=null) {
        let docUrl = null;
        let docTitle = null;
        if(clickElem.classList.contains('download')) {
            docUrl = $(clickElem).data('download');
            $('#'+targetModal).find('input#field_gated-download').val(docUrl);
            docTitle = $(clickElem).data('title');
            $('#'+targetModal).attr('data-download', docUrl);
        }
      $('.modal').each(function(){
        let modalId = $(this).attr('id');
        if(docTitle != null) {
            let formTitle = $(this).find('.form-title');
            if(formTitle) {
                let heading = formTitle.find('h3');
                
                heading.html('<span class="h3 alt">Download</span><br/> '+docTitle);
            }
        }


        if(targetModal === modalId ) {
          
            

          app.disable_scroll();

          $(this).addClass('active');
          $('body').addClass('modal-active');
          $('body').addClass('no-scroll');
          
          if($(this).parents('.building-row').length > 0) {
            $(this).parents('.building-row').addClass('modal-active');
          }

        }
      });
      
    },
    
    closeModal:function() {
        
      $('.modal .close, .modal .modal--close, .modal .button, .modal .cta').on('click', function(e){
        e.preventDefault();
        let href_on_close = $(e.target).attr('href');
        $(this).parents('.modal').removeClass('active');
        let target= $(this).parents('.modal').attr('id');
        $('body').removeClass('modal-active');
        $('body').removeClass('no-scroll');
        app.enable_scroll();
        $('.modal--trigger[href="#'+target+'"]').removeClass('active');
        $('.pullout--trigger[href="#'+target+'"]').removeClass('active');
        if($(this).parents('.building-row').length > 0) {
          let parentRow = $(this).parents('.building-row');
          setTimeout(function(){
            parentRow.removeClass('modal-active');
          }, 400);
        }
        if(href_on_close != undefined) {
          let active_cookie = target +'-activated';
          if(e.target.classList.contains('confirm')) {
                Cookies.set(active_cookie, true);
            }
          if(window.location != href_on_close) {
                window.location = href_on_close;  
            }

        }


      })
    },
    
    inView: function () {
      const animatedContent = document.querySelectorAll("[data-appear] .inview");
      
      const config = {
        rootMargin: '0px 0px -3% 0px'
      };

      let subNavLinks = $('.sub-navigation li a');

      let subNavBool = false;
      if(subNavLinks.length > 0) {
        subNavBool = true;
      }

      let observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          let parentRow = entry.target.closest("[data-appear]");
          let persistent = parentRow.getAttribute("data-persistent") == "1";
          let hasNavElem = parentRow.getAttribute("data-nav-elem");
          if (entry.intersectionRatio > 0) {
            entry.target.classList.add("visible");
              if(subNavBool) {
                subNavLinks.each(function(){
                  if($(parentRow).attr('id') === $(this).attr('href').substring(1) || $(parentRow).find('.hidden-anchor').attr('id') === $(this).attr('href').substring(1)) {
                    $(subNavLinks).removeClass('active');
                    $(this).addClass('active');
                  }
                });
              }
          } else {            
              if(subNavBool) {
                subNavLinks.each(function(){
                  if($(parentRow).attr('id') === $(this).attr('href').substring(1) || $(parentRow).find('.hidden-anchor').attr('id') === $(this).attr('href').substring(1)) {
                    $(this).removeClass('active');
                  }
                });
              }
          }
        });
      }, config);

      


      animatedContent.forEach((item) => {
        observer.observe(item);
      });




    },
    revealSlideOutTabs: function () {
      // Desktop reveals the tabs on hover (see _slide-out-tabs.scss). There is
      // no hover on touch, so below the stack breakpoint (991px) we slide each
      // tab in once its media block reaches the middle of the viewport.
      const mq = window.matchMedia('(max-width: 991px)');
      let observer = null;

      const teardown = () => {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        // Clear the revealed state so re-entering mobile re-runs the scroll
        // animation from scratch instead of showing tabs already pinned.
        document
          .querySelectorAll(".container.content-image-block .building-block.flexible-media.tab-revealed")
          .forEach((block) => block.classList.remove("tab-revealed"));
      };

      const setup = () => {
        teardown();

        if (!mq.matches) {
          return;
        }

        const mediaBlocks = document.querySelectorAll(
          ".container.content-image-block .building-block.flexible-media"
        );

        if (!mediaBlocks.length) {
          return;
        }

        // -40% bottom margin shrinks the root so a block only counts as
        // intersecting once its top edge has scrolled past ~60% of the
        // viewport, i.e. the user is into the row rather than at its top edge.
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.target.querySelector(".slide-out-tab")) {
              entry.target.classList.add("tab-revealed");
              observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '0px 0px -40% 0px'
        });

        mediaBlocks.forEach((block) => {
          if (block.querySelector(".slide-out-tab")) {
            observer.observe(block);
          }
        });
      };

      setup();

      // Re-arm when crossing the stack breakpoint so the triggers follow the
      // current viewport without needing a page refresh.
      if (typeof mq.addEventListener === "function") {
        mq.addEventListener("change", setup);
      } else if (typeof mq.addListener === "function") {
        mq.addListener(setup); // Safari < 14
      }
    },
    scrollTo: function (target) {
      

      if($('#'+target).length > 0 ) {
        let offsetTop = $('#'+target).offset().top;

        let headerHeight = $('header#header').outerHeight();
        
        
        
        if($('#sub-navigation').length > 0) {
          offsetTop = offsetTop - (headerHeight*1);
        } else {
          offsetTop = offsetTop - (headerHeight*1);
        }

        app.toggleNav(false);

        if(target ==='timeline-block') {
            offsetTop = $('#'+target).offset().top;
        
        }


        $("html, body").animate({
          scrollTop: offsetTop
        },1000)
        return false
      }
      
    },
    copyToClipboard: async function(elem, text) {
        try {
          await navigator.clipboard.writeText(text);
          elem.classList.add('clipboard-success');
          setTimeout(function(){
            elem.classList.remove('clipboard-success');
          },1000);
        } catch (err) {
         
        }
    },

    clipBoardLink: function(){ 
        $('.clipboard').on('click', async (e) => {
            let elem = e.target;
            let link = e.target.dataset.href;
            app.copyToClipboard(elem, link);
        });
    },
    initSelects: function() {

      setTimeout(function(){
        $('select').each(function(){
          $(this).select2({
            placeholder: $(this).data('placeholder'),
            minimumResultsForSearch: Infinity,
            dropdownParent:$(this).parents('.select-parent'),
          });
          
        });
      }, 500);
      
      $('.frm_other_input').each(function(){
        $(this).prop('placeholder', 'Type your response here')
      });
      
    },

    initFilter: function() {
    
    
    $('.filter .filter-inner > div').on('click', function () {
        $(this).parent().find('div').removeClass('active');
        $(this).addClass('active');
        handleFilterEvent($(this));
        let id = $(this).data('id');
          if (id === 'All' || id === undefined) {
            id = 'All';
        }
        
        // Close the filter accordion after selection
        let $filterAccordion = $(this).closest('.accordion.posts-filter');
        if($filterAccordion.length > 0 && $filterAccordion.hasClass('active')) {
          $filterAccordion.removeClass('active');
          $filterAccordion.find('.accordion--header').removeClass('active');
          $filterAccordion.find('.accordion--content').css('max-height', '0px');
        }
      
      });

      function handleFilterEvent($element) {
        let $button = $('.button.load-more');
        let filter_term = $element.data('filter-term');
        // console.log('The data filter term value is:  ' + filter_term);

        let id = $element.val() || $element.data('id');
        

        // If id is undefined, set it to 'All'
          if (typeof id === 'undefined') {
            id = 'All';
        }

        // console.log('The id value is:  ' + id);

        let post_type;
        let posts_per_page;
        let category;

        if(filter_term === 'category') {
          $button.data('post-category', id);
        } 
        post_type = $button.data('post-type');
        posts_per_page = $button.data('ppp');
        category = $button.data('post-category');
      
        $.ajax({
            url: ajax_object.ajax_url,
            data: {
                'action': 'filter',
                'post_type': post_type,
                'category' : category,
                'posts_per_page' : posts_per_page,
            },
            type: 'POST',
            dataType:'json',
            beforeSend: function (xhr) {
              $button.text('Loading...');
            },
            success: function (res) {
             
              if (res) {
                // console.log(res); 
                if(res.html) {
                    $('#posts-container').html(res.html);
                
                    if(res.total_posts > res.posts_per_page) {
                        $button.parent().removeClass('hide');
                        $button.text('Load more');
                    } else {
                      $button.parent().addClass('hide');
                     
                    }
                } else {
                  $button.parent().addClass('hide');
                 
                }
              }
            }
        });
    }
    },

     initLoadMore: function() {
      let current_page = 1;

      $('button.load-more').on('click',function () {
        
          let current_posts = $('#posts-container .card.post').length;
          
    
          let post_type = $(this).data('post-type');
          let posts_per_page = $(this).data('ppp');
          let category = $(this).data('post-category');
          let $button = $(this);

        

        $.ajax({ // you can also use $.post here
          url: ajax_object.ajax_url, // AJAX handler
          data: {
              'action': 'loadmore',
              'current_posts': current_posts,
              'post_type' : post_type,
              'category' : category,
              'posts_per_page' : posts_per_page,
              'current_page' : current_page,
          },
          type: 'POST',
          dataType:'json',
          beforeSend: function (xhr) {

            $button.text('Loading...') // change the button text, you can also add a preloader image
          },
          success: function (res) {
          
            if (res) {
          
              $button.text('Load more')
              $('#posts-container').append(res.html) // insert new posts
              current_page++
              
              // Recalculate current_posts from actual DOM count
              current_posts = $('#posts-container .card.post').length;

              
              if(current_posts >= res.total_posts) {
                $button.parent().addClass('hide');
                } else {
                    $button.parent().removeClass('hide');
                }
            } else {
                $button.parent().addClass('hide'); // if no data, remove the button as well
            }
          },
          error: function(xhr, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            alert(err.Message);
          }
        })
      })
    },


   
   
 




    initPagination: function() {
      
       let current_page = 1;



        
            
        ////get url with params if there
        let current_url = new URL(window.location.href);

        ///search for params and save em
        let current_params = new URLSearchParams(current_url.search);

        let current_page_url = current_params.get('paged');
        let filter_link = current_params.get('filter');
        if(filter_link === undefined) {
          if(current_page_url != undefined) {
            current_page = current_page_url;
          }
          
          let parent_row = $('#posts-pagination').parents('.building-row');

          let $button = parent_row.find('button.load-more');
          
          $button.parent().removeClass('hide');

          

          let localised_pagination_container = parent_row.find('#posts-pagination');

          let post_type = $button.data('post-type');
          let posts_per_page = $button.data('ppp');
          let categories = $button.data('categories');
          let industries = $button.data('industries');
          let services = $button.data('services');
          let solutions = $button.data('solutions');
          let pagination = $button.data('pagination');
          let knowledge_hub_type = $button.data('knowledge-hub-type');
          let team_location = $button.data('team-location');
          let creditors_location = $button.data('creditors-location');
          let creditors_appointment = $button.data('creditors-appointment');
          let current_posts = $('#posts-container .card').length;
      
          current_url.search = current_params.toString();

          current_url = current_url.toString();
          
          $.ajax({ // you can also use $.post here
              url: ajax_object.ajax_url, // AJAX handler
              data: {
                  'action': 'pagination',
                  'current_posts': current_posts,
                  'post_type' : post_type,
                  'posts_per_page' : posts_per_page,
                  'current_page' : current_page,
                  'current_url' : current_url,
                  'category' : categories,
                  'services' : services,
                  'industries' : industries,
                  'solutions' : solutions,
                  'pagination' : pagination,
                  'knowledge_hub_type' : knowledge_hub_type,
                  'creditors_appointment' : creditors_appointment,
                  'creditors_location' : creditors_location,
                  'team_location' : team_location
              },
              type: 'POST',
              dataType:'json',
              beforeSend: function (xhr) {
              },
              success: function (res) {
                  if (res) {

                      if(res.html != null) {

                          $('#posts-container').html(res.html) // insert new posts
                          ////get url with params if there
                          let new_url = new URL(window.location.href);
                          ///search for params and save em
                          let params = new URLSearchParams(new_url.search);
            
                          let paramsPaged = params.get('paged');
      
                          params = new URLSearchParams(new_url.search);
                          params = params.delete('paged');
                          if(params === undefined) {
                              params ='';
                          }
                          new_url.search = params.toString();
                          new_url = new_url.toString()+'?paged='+current_page;
                          window.history.replaceState({}, "", new_url);

                      } 

                      if(res.pagination != null) {
                          localised_pagination_container.html(res.pagination) // insert new posts
                      }
                  } else {
                  $button.parent().addClass('hide'); // if no data, remove the button as well
                  }
              },
              error: function(xhr, status, error) {
                  var err = eval("(" + xhr.responseText + ")");
                  alert(err.Message);
              }
          });

        }
        


        ////for back / forward button clicks
        window.addEventListener('popstate', function(event) {

            if(event.state) {
                ////get url with params if there
                let current_url = new URL(window.location.href);

                ///search for params and save em
                let current_params = new URLSearchParams(current_url.search);

                let current_page_url = current_params.get('paged');
                if(current_page_url != undefined) {
                    current_page = current_page_url;
                }
                if($('#posts-pagination').length > 0) {
                  let parent_row = $('#posts-pagination').parents('.building-row');

                  let $button = parent_row.find('button.load-more');
                  
                  $button.parent().removeClass('hide');

                  let localised_pagination_container = parent_row.find('#posts-pagination');

                  let post_type = $button.data('post-type');
                  let posts_per_page = $button.data('ppp');
                  let categories = $button.data('categories');
                  let industries = $button.data('industries');
                  let services = $button.data('services');
                  let solutions = $button.data('solutions');
                  let pagination = $button.data('pagination');
                  let knowledge_hub_type = $button.data('knowledge-hub-type');
                  let team_location = $button.data('team-location');
                  let creditors_location = $button.data('creditors-location');
                  let creditors_appointment = $button.data('creditors-appointment');
                  let current_posts = $('#posts-container .card').length;
              
                  current_url.search = current_params.toString();

                  current_url = current_url.toString();
                  
                  $.ajax({ // you can also use $.post here
                      url: ajax_object.ajax_url, // AJAX handler
                      data: {
                          'action': 'pagination',
                          'current_posts': current_posts,
                          'post_type' : post_type,
                          'posts_per_page' : posts_per_page,
                          'current_page' : current_page,
                          'current_url' : current_url,
                          'category' : categories,
                          'services' : services,
                          'industries' : industries,
                          'solutions' : solutions,
                          'pagination' : pagination,
                          'knowledge_hub_type' : knowledge_hub_type,
                          'creditors_appointment' : creditors_appointment,
                          'creditors_location' : creditors_location,
                          'team_location' : team_location
                      },
                      type: 'POST',
                      dataType:'json',
                      beforeSend: function (xhr) {
                      },
                      success: function (res) {
                          if (res) {

                              if(res.html != null) {

                                  $('#posts-container').html(res.html) // insert new posts
                                  ////get url with params if there
                                  let new_url = new URL(window.location.href);
                                  ///search for params and save em
                                  let params = new URLSearchParams(new_url.search);
                          
                                  let paramsPaged = params.get('paged');
                          
                                  params = new URLSearchParams(new_url.search);
                                  params = params.delete('paged');
                                  if(params === undefined) {
                                      params ='';
                                  }
                                  new_url.search = params.toString();
                                  new_url = new_url.toString()+'?paged='+current_page;
                                  window.history.replaceState({}, "", new_url);

                              } 

                              if(res.pagination != null) {
                                  localised_pagination_container.html(res.pagination) // insert new posts
                              }
                          } else {
                          $button.parent().addClass('hide'); // if no data, remove the button as well
                          }
                      },
                      error: function(xhr, status, error) {
                          var err = eval("(" + xhr.responseText + ")");
                          alert(err.Message);
                      }
                  });
                }
                
            } else {

                ///initial state / no recorded state param


            }

        });



        $(document).on('click' ,'#posts-pagination a',function (e) {

            e.preventDefault();

            let linkText = $(this).text();

            let parent_row = $(this).parents('.building-row');

            let $button = parent_row.find('button.load-more');
            
            $button.parent().removeClass('hide');

            let localised_pagination_container = parent_row.find('#posts-pagination');

            let post_type = $button.data('post-type');
            let posts_per_page = $button.data('ppp');
            let categories = $button.data('categories');
            let industries = $button.data('industries');
            let services = $button.data('services');
            let solutions = $button.data('solutions');
            let pagination = $button.data('pagination');
            let knowledge_hub_type = $button.data('knowledge-hub-type');
            let team_location = $button.data('team-location');
            let creditors_location = $button.data('creditors-location');
            let creditors_appointment = $button.data('creditors-appointment');
            let current_posts = $('#posts-container .card').length;

            $("html, body").animate({
                scrollTop: 0
            },0)
            if($(this).hasClass('next')) {
                        
            current_page++;

            } else if($(this).hasClass('prev')) {
                current_page--;
                if(current_page < 1) {
                    current_page = 1;
                }
            } else {
                current_page = linkText;
            }
            ////get url with params if there
            let current_url = new URL(window.location.href);

            ///search for params and save em
            let current_params = new URLSearchParams(current_url.search);

            current_params = current_params.delete('paged');

            if(current_params === undefined) {
                current_params = '';
            }
            current_url.search = current_params.toString();

            current_url = current_url.toString();
            
            $.ajax({ // you can also use $.post here
                url: ajax_object.ajax_url, // AJAX handler
                data: {
                    'action': 'pagination',
                    'current_posts': current_posts,
                    'post_type' : post_type,
                    'posts_per_page' : posts_per_page,
                    'current_page' : current_page,
                    'current_url' : current_url,
                    'category' : categories,
                    'services' : services,
                    'industries' : industries,
                    'solutions' : solutions,
                    'pagination' : pagination,
                    'knowledge_hub_type' : knowledge_hub_type,
                    'creditors_appointment' : creditors_appointment,
                    'creditors_location' : creditors_location,
                    'team_location' : team_location
                },
                type: 'POST',
                dataType:'json',
                beforeSend: function (xhr) {
                },
                success: function (res) {
                    if (res) {

                        if(res.html != null) {

                            $('#posts-container').html(res.html) // insert new posts
                            ////get url with params if there
                            let new_url = new URL(window.location.href);
                            ///search for params and save em
                            let params = new URLSearchParams(new_url.search);
                            
                            let paramsPaged = params.get('paged');
                            
                            params = new URLSearchParams(new_url.search);
                            params = params.delete('paged');
                            if(params === undefined) {
                                params ='';
                            }
                            new_url.search = params.toString();
                            new_url = new_url.toString()+'?paged='+current_page;
                            window.history.pushState({page: current_page}, "", new_url);

                        } 

                        if(res.pagination != null) {
                            localised_pagination_container.html(res.pagination) // insert new posts
                        }
                    } else {
                    $button.parent().addClass('hide'); // if no data, remove the button as well
                    }
                },
                error: function(xhr, status, error) {
                    var err = eval("(" + xhr.responseText + ")");
                    alert(err.Message);
                }
            })
        })
    },
    initSwipers: function () {
            // Destroy existing swiper instances
            if(swiperCollection.length > 0) {
                swiperCollection.forEach(swiper => {
                    if(swiper && typeof swiper.destroy === 'function') {
                        swiper.destroy(true, true);
                    }
                });
                swiperCollection = [];
            }

            let swiperInstances = $(".swiper:not('logos')");
        
           
            /// app.swiperConstructor(instances, nested);
            if(swiperInstances.length > 0 ) {
                app.swiperConstructor(swiperInstances);
            }
          
        },

        swiperConstructor: function (instances) {

            

            instances.each(function (index, el) {
                
                const progressElems = el.querySelectorAll(".autoplay-progress .progress-line");

                let swiper_parent = $(el).parents(".building-block");
                if ($(el).parents(".tab-content").length > 0) {
                    swiper_parent = $(el).parents(".tab-content");
                } else if ($(el).parents(".card-image").length > 0) {
                    swiper_parent = $(el).parents(".card-image");
                }
                swiper_parent.addClass(
                    "carousel-parent-index-" + parseFloat(parseFloat(index) + 1)
                );
                $(el).addClass(
                    "carousel-index-" + parseFloat(parseFloat(index) + 1)
                );
                
                el = $(
                    ".carousel-parent-index-" +
                        parseFloat(parseFloat(index) + 1) +
                        " .carousel-index-" +
                        parseFloat(parseFloat(index) + 1) +
                        ""
                );
                
                let uniqueSlider = $(el)[0];
                
                let navigationObject = false;
                if ($(uniqueSlider).data("navigation")) {
                    navigationObject = {
                        nextEl:
                            ".carousel-parent-index-" +
                            parseFloat(parseFloat(index) + 1) +
                            " .swiper-button-next",
                        prevEl:
                            ".carousel-parent-index-" +
                            parseFloat(parseFloat(index) + 1) +
                            " .swiper-button-prev",
                    };
                }

                if ($(el).parents(".building-block.post-carousel").length > 0) {
                    if ($(uniqueSlider).data("navigation")) {
                        navigationObject = {
                            nextEl:
                                ".carousel-parent-index-" +
                                parseFloat(parseFloat(index) + 1) +
                                " .swiper-button-next",
                            prevEl:
                                ".carousel-parent-index-" +
                                parseFloat(parseFloat(index) + 1) +
                                " .swiper-button-prev",
                        };
                    }
                }

                let paginationObject = false;
                if ($(uniqueSlider).data("pagination")) {
                    paginationObject = {
                        el:
                            ".carousel-parent-index-" +
                            parseFloat(parseFloat(index) + 1) +
                            " .swiper-pagination",
                        type: "bullets",
                        clickable: true,
                    };
                }
                let mobileLoop = $(uniqueSlider).data("loop");
                
                let direction = "horizontal";

                if ($(uniqueSlider).data("direction")) {
                    direction = $(uniqueSlider).data("direction");
                }

                let touchMove = true;
                let simulateTouch = true;

                let centeredSlides = false;
                if ($(uniqueSlider).data("centred-slides")) {
                    centeredSlides = true;
                }
                // Center slides for mobile option
              
                let mousewheel = {
                    forceToAxis: true,
                };

                if ($(uniqueSlider).data("touch-move") == false) {
                    touchMove = false;
                    simulateTouch = false;
                    // centeredSlides = true;
                    mousewheel = false;
                }

                let auto_height = false;
                if ($(uniqueSlider).data("auto-height")) {
                    auto_height = $(uniqueSlider).data("auto-height");
                }

                let disableOnInteraction = true;
                if (
                    $(uniqueSlider).data("disable-interaction") === false ||
                    $(uniqueSlider).data("disable-interaction") === "false"
                ) {
                    disableOnInteraction = false;
                    mousewheel = false;
                }

                let freemode = false;
                if (
                    $(uniqueSlider).data("freemode") == "true" ||
                    $(uniqueSlider).data("freemode") == true
                ) {
                    freemode = true;
                    mousewheel = false;
                }

                let initialSlide = 0;
                if ($(uniqueSlider).data("initial-slide") != undefined) {
                    initialSlide = $(uniqueSlider).data("initial-slide");
                }
                let enabled = true;
                let init = true;
                if (
                    $(uniqueSlider).data("static-desktop") == "true" ||
                    $(uniqueSlider).data("static-desktop") == true
                ) {
                    if ($(window).outerWidth() > 992) {
                        init = false;
                        enabled = false;
                    }
                }
                let autoplay = false;
                 if($(uniqueSlider).data("autoplay")) {
                    autoplay = {
                        delay: parseFloat($(uniqueSlider).data("delay")),
                        reverseDirection: $(uniqueSlider).data("reverse-autoplay"),
                    }
                 }

                 let thumbs = false;

                 if($(uniqueSlider).data("thumbs")) {
                    let galleryThumbsElem = $(uniqueSlider).data("thumbs");
                    galleryThumbsElem = document.getElementById(galleryThumbsElem);
                    let galleryThumbsSwiper = galleryThumbsElem.swiper;
                    

                    thumbs = {
                        swiper: galleryThumbsSwiper
                    }
                 }

                swiperCollection[index] = new Swiper(uniqueSlider, {
                    direction: direction,
                    autoplay: autoplay,
                    speed: parseInt($(uniqueSlider).data("speed"), 10),
                    effect: $(uniqueSlider).data("effect"),
                    loop: mobileLoop,
                    observer: true,
                    observeParents: true,
                    navigation: navigationObject,
                    pagination: paginationObject,
                    slidesPerGroup: 1,
                    slidesPerView: parseFloat($(uniqueSlider).data("slides-per-view-mobile")),
                    spaceBetween: $(uniqueSlider).data("space-between-mobile"),
                    disableOnInteraction: disableOnInteraction,
                    allowTouchMove: touchMove,
                    freeMode: freemode,
                    simulateTouch: simulateTouch,
                    centeredSlides: centeredSlides,
                    mousewheel:false,
                    enabled: enabled,
                    autoHeight: auto_height,
                    init: init,
                    initialSlide: initialSlide,
                    watchSlidesProgress: true,
                    thumbs:thumbs,
                    breakpoints: {
                        600: {
                            slidesPerView:
                                $(uniqueSlider).data("slides-per-view-tablet") == "auto"
                                    ? "auto"
                                    : parseFloat($(uniqueSlider).data("slides-per-view-tablet")),
                            spaceBetween: $(uniqueSlider).data("space-between-tablet"),
                        },
                        992: {
                            slidesPerView:
                                $(uniqueSlider).data("slides-per-view") ==
                                "auto"
                                    ? "auto"
                                    : parseFloat(
                                          $(uniqueSlider).data(
                                              "slides-per-view"
                                          )
                                      ),
                            spaceBetween: $(uniqueSlider).data("space-between"),
                            mousewheel: {
                                forceToAxis:true
                            },
                        },
                    },
                    on: {
                        init: function () {
                            let swiper = $(this);
                            progressElems.forEach((elem, i) => {

                                elem.style.setProperty("--delay", ((parseFloat($(uniqueSlider).data("delay")) - parseFloat($(uniqueSlider).data("speed")))/1000)+'s');
                            })
                        },
                        autoplayTimeLeft(s, time, progress) {
                            
                       
                            
                        },
                        beforeSlideChangeStart:function(){

                            let swiper = $(this);
                            
                            let sliderVideos = $(uniqueSlider).find('.swiper-slide:not(.swiper-slide-active) video');
                            
                            sliderVideos.each(function(){
                                let video = $(this);
                                video[0].pause();
                                video[0].currentTime = 0;
                            });
                            
                        },
                        slideChangeTransitionStart: function() {
                            let swiper = $(this);
                            let sliderVideos = $(uniqueSlider).find('.swiper-slide-active video');
                            
                            sliderVideos.each(function(){
                                let video = $(this);
                                video[0].currentTime = 0;
                                video[0].play();
                                
                            });

                        },
                        slideChangeTransitionEnd:function(){
                          
                            
                        },
                    },
                });

                if ($(uniqueSlider).parents(".interactive-tiles-slider").length > 0 && $(window).outerWidth() > 992) {
                    let slideloop = 0;
                    $(uniqueSlider)
                        .find(".swiper-slide")
                        .each(function () {
                            let currentSlide = $(this);
                            if (slideloop === 0) {
                                currentSlide.addClass("hover-active");
                            }

                            if ($(window).outerWidth() > 992) {
                                currentSlide.on("mouseenter", function () {
                                    currentSlide
                                        .siblings()
                                        .removeClass("hover-active");
                                    currentSlide
                                        .siblings()
                                        .removeClass("overlay-active");
                                    currentSlide.addClass("hover-active");
                                });
                            }

                            

                            slideloop++;
                        });
                }
              
            });
        },


      initLogoTickerSwiper() {
      // Destroy existing instance if it exists
      if (logoTickerSwiper !== null && logoTickerSwiper !== undefined) {
        logoTickerSwiper.destroy(true, true);
        logoTickerSwiper = null;
      }

      // Only initialize if the element exists
      if ($('.building-block.ticker-slider .column--inner .swiper.logos').length > 0) {
        logoTickerSwiper = new Swiper('.building-block.ticker-slider .column--inner .swiper.logos', {
        direction:'horizontal',
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed: 4000,
        effect: 'slide',
        loop: true,
        observer: true,
        observeParents: true,
        navigation: false,
        pagination: false,
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        spaceBetween: 0,
        allowTouchMove: false,
        freeMode: true,
        simulateTouch: false,
        centeredSlides: false,
        mousewheel: false,
        enabled: true,
        init: true,
        autoHeight: false,
        watchSlidesProgress: true,
        });
      }
    },

    initNewsletter:function(){
      
      let newsletter_title = $('.building-block.newsletter .title-inner');

      if($(window).outerWidth() < 992) {
        newsletter_title.on("click", function () {
      
          let newsletter_parent = $(this).parents('.building-block');
    
          if(newsletter_parent.hasClass('active')) {
            newsletter_parent.removeClass('active');
            newsletter_parent.find('.content-inner').css('max-height', '0px')
          } else {
            newsletter_parent.addClass('active');
  
            let innerContent = newsletter_parent.find('.frm_forms');
           
            if(innerContent.length < 1) {
              innerContent = newsletter_parent.find('.hbspt-form');
           
            }
    
            newsletter_parent.find('.content-inner').css('max-height', innerContent.outerHeight() + 60 + 'px')
    
          }
  
  
        });
      }


      
    },
    matchServiceLine: function() {

        const logicMap = {
            "Commerce & Business|Financial Services": [{url: "/expertise/services/restructuring", name: "Restructuring"}, {url: "/expertise/services/performance-improvement" , name: "Performance Improvement"}, {url: "/expertise/services/risk-advisory/climate-sustainability-esg-risk" , name: "Sustainability"}],
            "Commerce & Business|Real Estate and Construction": [{url: "/expertise/services/restructuring" , name: "Restructuring"}],
            "Commerce & Business|Retail and Hospitality": [{url: "/expertise/services/restructuring" , name: "Restructuring"}, {url: "/expertise/services/performance-improvement" , name: "Performance Improvement"}],
            "Law|Defence and National Security": [{url: "/expertise/services/risk-advisory/financial-crime-risk-compliance" , name: "Financial Crime"}, {url: "/expertise/services/risk-advisory/climate-sustainability-esg-risk" , name: "Sustainability"}],
            "Law|Public Sector": [{url: "/expertise/services/risk-advisory/financial-crime-risk-compliance" , name: "Financial Crime"}, {url: "/expertise/services/risk-advisory/climate-sustainability-esg-risk" , name: "Sustainability"}],
            "Engineering|Infrastructure and Precincts": [{url: "/expertise/services/major-projects-advisory" , name: "Major Projects Advisory"}, {url: "/expertise/services/risk-advisory/climate-sustainability-esg-risk" , name: "Sustainability"}],
            "Engineering|Energy and Natural Resources": [{url: "/expertise/services/major-projects-advisory" , name: "Major Projects Advisory"}, {url: "/expertise/services/risk-advisory/climate-sustainability-esg-risk" , name: "Sustainability"}],
            "Computer Science & IT|Technology, Telecommunications and Media": [{url: "/expertise/services/technology-data" , name: "Technology and Data"}, {url: "/expertise/services/cyber-digital-forensic" , name: "Forensic Technology"}],
            "Data & Analytics|Health": [{url: "/expertise/services/forensic/forensic-data-analytics" , name: "Forensic Data Analytics"}, {url: "/expertise/services/technology-data" , name: "Technology and Data"}],
            "Data & Analytics|Education": [{url: "/expertise/services/forensic/forensic-data-analytics" , name: "Forensic Data Analytics"}, {url: "/expertise/services/technology-data" , name: "Technology and Data"}],
            "Property & Urban Planning|Real Estate and Construction": [{url: "/expertise/services/real-estate-advisory" , name: "Real Estate Advisory"}, {url: "/expertise/services/major-projects-advisory" , name: "Major Projects Advisory"}],
            "Criminology & Security|Defence and National Security": [{url: "/expertise/services/risk-advisory/financial-crime-risk-compliance" , name: "Financial Crime"}],
            "Environmental & Sustainability Sciences|Energy and Natural Resources": [{url: "/expertise/services/risk-advisory/climate-sustainability-esg-risk" , name: "Sustainability"}],
            "Environmental & Sustainability Sciences|Agriculture": [{url: "/expertise/services/risk-advisory/climate-sustainability-esg-risk" , name: "Sustainability"}]
        };


        const resultsDiv = document.getElementById("results");
        const careerPathways = document.getElementById('pathways-container');
        
        
        const degree = careerPathways.dataset.degree;
        const industry = careerPathways.dataset.industry;


        resultsDiv.innerHTML = "";

        if (!degree || !industry) {
            resultsDiv.innerHTML = "<p>Please select both a degree and an industry.</p>";
            return;
        }

        const key = `${degree}|${industry}`;
        const matches = logicMap[key];

        if (matches) {
            resultsDiv.innerHTML = "<h3>Recommended Service Line(s):</h3>";
            resultsDiv.innerHTML += "<ul class='no-styling'>"+matches.map(m => `<li><a href="${m.url}" class="button bg-blue solid"><span>${m.name}</span></a></li>`).join("")+"</ul>";
        } else {
            resultsDiv.innerHTML = "<p>We didn’t find a perfect match, but here are some options that might still interest you:</p>";
            resultsDiv.innerHTML += "<p><strong>Explore all service lines:</strong></p><ul class='no-styling'>" +"<li><a href='/expertise/services/' class='solid bg-blue button'><span>View our Services</span></a></li>" + "</ul>";
        }
    },
    careersPathways:function(){
      const careerPathways = document.getElementById('pathways-container');
        $('#career-pathways .button').on('click touch', function(){
        
          


          console.log('pathways button click');

          if($(this).parents('#degree').length > 0) {
            
            let degree = $(this).data('degree');
            console.log(degree);
            
            careerPathways.dataset.degree = degree;

          } else if($(this).parents('#industry').length > 0) {

            let industry = $(this).data('industry');
            console.log(industry);

            careerPathways.dataset.industry = industry;

          
              app.matchServiceLine();
           
            
          }


          let primaryDelay = 350;
        let secondaryDelay = 150;

        let currentTab = $(this).parents('.button-group-container');
        
        let nextTab = currentTab.next();

        let prevTab = currentTab.prev();

       let newHeight = nextTab.outerHeight();

       let prevHeight = prevTab.outerHeight();

        if($(window).outerWidth() < 992) {
            primaryDelay = 350;
            secondaryDelay = 150;
        }

        if(!$(this).hasClass('back')) {
            

            nextTab.addClass('display');

            currentTab.removeClass('active');

            setTimeout(function(){
                currentTab.addClass('inactive');
                
            }, secondaryDelay+200);

            setTimeout(function(){
                nextTab.parents('.pathways-container').css('height', newHeight+'px');
                nextTab.removeClass('inactive');
                nextTab.addClass('active');
                
            }, primaryDelay+200);

            setTimeout(function(){
                currentTab.removeClass('display');
            }, primaryDelay+200);
                
        } else {
            
            
            prevTab.addClass('display');

            setTimeout(function(){
                prevTab.removeClass('inactive');
                prevTab.addClass('active');
            }, primaryDelay);

            currentTab.removeClass('active');
            
           

            setTimeout(function(){
                currentTab.addClass('inactive');

                

            }, secondaryDelay);

            setTimeout(function(){
                currentTab.removeClass('display');
                prevTab.parents('.pathways-container').css('height', prevHeight+'px');
            }, primaryDelay);

        }
          

          

        });
    
    },

    gridSlideAnimate: function() {
      let buildingBlockGridContentSector = $('.building-block.grid-content.sector');

      let gridItemSlideTrigger = buildingBlockGridContentSector.find('.grid-item.sector .sector-cta-trigger');

      function setGridContentHeight() {
        if($(window).width() >= 992) {
          $('.building-block.grid-content.sector.active').each(function() {
            let activeContentDiv = $(this).find('.grid-item-content-container .active');
            if(activeContentDiv.length > 0) {
              let contentHeight = activeContentDiv.outerHeight();
              // $(this).css('max-height', contentHeight + 'px');
            }
          });
        } else {
          // $('.building-block.grid-content.sector').css('max-height', '');
        }
      }

      gridItemSlideTrigger.on('click', function(){
        let clickedGridItem = $(this).closest('.grid-item.sector');
        let sectorSlug = clickedGridItem.data('sector');
        
        // Add active class to only the building block containing this grid item
        let parentBuildingBlock = $(this).closest('.building-block.grid-content.sector');
        parentBuildingBlock.addClass('active');

        // Hide the grid container after transition completes (300ms delay)
        setTimeout(function() {
          parentBuildingBlock.find('.grid-container').css('visibility', 'hidden');

        }, 150);
        
        // Find the matching content div and add active class
        let gridItemContentContainer = parentBuildingBlock.find('.grid-item-content-container');
        let matchingContentDiv = gridItemContentContainer.find('.' + sectorSlug);
        matchingContentDiv.addClass('active');
        
        // Scroll to the active content div after 300ms delay
        setTimeout(function() {
          let headerHeight = $('header#header').outerHeight() || 0;
          let headerContainerOffset = 80;
          let scrollTarget = matchingContentDiv.offset().top - headerHeight - headerContainerOffset;
          
          $('html, body').animate({
            scrollTop: scrollTarget
          }, 1000);
        }, 100);
        
        // Calculate and apply height only on desktop
        setGridContentHeight();
      });

      // Close trigger functionality
      buildingBlockGridContentSector.find('.close-trigger').on('click', function(){
        let parentBuildingBlock = $(this).closest('.building-block.grid-content.sector');
        
        // Remove active classes
        parentBuildingBlock.removeClass('active');
        parentBuildingBlock.find('.grid-item-content-container > div').removeClass('active');

        // Make grid visible again
        parentBuildingBlock.find('.grid-container').css('visibility', 'visible');
        
        
        // Remove max-height
        // parentBuildingBlock.css('max-height', '');
      });

      // Recalculate on window resize
      $(window).on('resize', function() {
        setGridContentHeight();
      });
      
    },

    equaliseCardTitles: function () {
      // .card-content-container is a flex column, so .card-content starts wherever
      // .card-title ends and titles of differing line counts leave the content
      // sitting at different heights. Measure the tallest title in each row and
      // pad the shorter ones up to match. Measuring rather than reserving a fixed
      // number of lines means a block of one-line titles stays tight while a block
      // of three-line titles still aligns, with no per-block config.
      const containers = document.querySelectorAll(
        '.grid-container, .building-block.card-carousel .swiper-wrapper'
      );

      containers.forEach((container) => {
        const titles = container.querySelectorAll('.card.custom .card-title h4');

        if (titles.length < 2) {
          return;
        }

        // Clear previous passes so we measure natural height, not the last result.
        titles.forEach((title) => {
          title.style.minHeight = '';
        });

        // Grid blocks wrap onto multiple rows, so align within a row rather than
        // across the whole block - a long title on row two shouldn't add
        // whitespace to row one. Group by the card's top edge (not the title's) so
        // a subtitle that wraps doesn't split a row in two. Carousel slides all
        // share a top edge and fall into a single group.
        const measured = Array.from(titles).map((title) => {
          const card = title.closest('.card.custom') || title;
          return { title: title, top: card.getBoundingClientRect().top };
        }).sort((a, b) => a.top - b.top);

        const rows = [];
        measured.forEach((entry) => {
          const currentRow = rows[rows.length - 1];
          // 5px tolerance absorbs sub-pixel differences within a row.
          if (currentRow && Math.abs(entry.top - currentRow.top) < 5) {
            currentRow.titles.push(entry.title);
          } else {
            rows.push({ top: entry.top, titles: [entry.title] });
          }
        });

        rows.forEach((row) => {
          if (row.titles.length < 2) {
            return;
          }

          const tallest = Math.max.apply(null, row.titles.map((title) => {
            return title.getBoundingClientRect().height;
          }));

          row.titles.forEach((title) => {
            title.style.minHeight = tallest + 'px';
          });
        });
      });
    },

    initAccordions: function () {
      let accordions = $('.accordion--header');

      

      accordions.on("click", function () {
        
        
      

        app.toggleAccordion($(this).parents('.accordion'));




      });

      // accordions.each(function(){
      //   if($(this).hasClass('active')) {
      //     $(this).trigger('click');
      //   }
      // });
      
    },
    
    toggleAccordion: function (ac) {


      $('.accordion').not(ac).each(function(){
        $(this).removeClass('active');
        $(this).find('.accordion--header').removeClass('active');
        $(this).find('.accordion--content').css('max-height', '0px')
      });

      if(ac.hasClass('active')) {
        ac.removeClass('active');
        ac.find('.accordion--header').removeClass('active');
        ac.find('.accordion--content').css('max-height', '0px')
      } else {
        ac.addClass('active');
        ac.find('.accordion--header').addClass('active');
        let innerContent = ac.find('.accordion--content-wrapper');

        ac.find('.accordion--content').css('max-height', innerContent.outerHeight() + 60 + 'px')

      }
      
      
    },
    toggleCardContent: function () {

      $('.card.expertise:not(.case-study)').on('mouseenter', function(){
          $(this).find('.content-container').addClass('active');
          let innerContent = $(this).find('.content-container .content-group');

          $(this).find('.content-container').css('max-height', innerContent.outerHeight() + 60 + 'px');
      })

      $('.card.expertise:not(.case-study)').on('mouseleave', function(){
          $(this).removeClass('active');
        
$(this).find('.content-container').removeClass('active');
          $(this).find('.content-container').css('max-height', '0px');
      });
      
    },

      closeExpandCardContent: function() {
      $(document).on('click', '.card--close-button', function(){
        let closeBtn = $(this);
        closeBtn.parents('.expandable--content').removeClass('active');
        closeBtn.parents('.expandable--content').prev().removeClass('active');
        closeBtn.parents('.expandable--content').css('max-height', '0px');
        $('.team .card.post').removeClass('active');
        $('.team-members .card').removeClass('inactive');

      });
    },
    expandCardContent: function() {

     
      $('.team-members .card').on('click', function(){
        if($(this).data('content') != undefined && $(this).find('.card--content-trigger').length > 0) {
          
          let cardIndex = $(this).index();
          let cardContent = $(this).data('content');
          
          // Find the expandable content for this card's row based on viewport
          let expandableContent;
          
          if($(window).width() <= 991) {
            // Mobile: 1 column - next expandable after current card
            expandableContent = $(this).nextAll('.expandable--content').first();
          } else {
            // Desktop: 4 columns - next .desktop expandable
            expandableContent = $(this).nextAll('.expandable--content.desktop').first();
          }

          // Check if clicking the same active card (toggle close)
          if($(this).hasClass('active')) {
            $(this).removeClass('active');
            expandableContent.css('max-height', '0px');
            expandableContent.removeClass('active');
            // Remove inactive class from all cards when closing
            $('.team-members .card').removeClass('inactive');
            return;
          }
          
          // Check if there's already an active card in the same row
          let sameRowActive = expandableContent.hasClass('active');
          
          if(!sameRowActive) {
            // Different row or no active content - close all others first
            $('.expandable--content').css('max-height', '0px');
            $('.expandable--content').removeClass('active');
            $('.team-members .card').removeClass('active');
            $('.team-members .card').removeClass('inactive');
            
            // Add content and open
            $(this).addClass('active');
            $('.team-members .card').not($(this)).addClass('inactive');
            expandableContent.find('.expandable--content-inner').html(cardContent);
            
            let newContentHeight = expandableContent.find('.expandable--content-inner').outerHeight();
            expandableContent.addClass('active');
            expandableContent.css('max-height', newContentHeight+'px');
          } else {
            // Same row - fade out, swap content, fade in
            $('.team-members .card').not($(this)).removeClass('active');
            $('.team-members .card').not($(this)).addClass('inactive');
            $(this).addClass('active');
            $(this).removeClass('inactive');
            
            let contentInner = expandableContent.find('.expandable--content-inner');
            expandableContent.removeClass('active');
            
            setTimeout(function() {
              contentInner.html(cardContent);
              let newContentHeight = contentInner.outerHeight();
              expandableContent.css('max-height', newContentHeight+'px');
              
              setTimeout(function() {
                expandableContent.addClass('active');
              }, 10);
            }, 200);
          }
        }
      });

      app.closeExpandCardContent();

    },
   
   
    affixNavigation: function(st, lastScrollTop) {
      let headerNavigation = $('header#header');
      let navScrollBool = ($(window).outerHeight()) * 0.75;
      // let navScrollBool = $('#hero').outerHeight();
      
      if(st > (navScrollBool)) {
        headerNavigation.addClass('header-scroll');
        $('body').addClass('header-scroll');
      
      } else {
        headerNavigation.removeClass('header-scroll');
        $('body').removeClass('header-scroll');
      }

    },
        
    
    tabNavScrollActivate:function(st) {
      $('.tab-content').each(function(){
        if(($(this).offset().top - 175) < st) {
          let tabID = $(this).attr('id');
          $('.tab-navigation a').removeClass('active');
          $('.tab-navigation a[href="#'+tabID+'"]').addClass('active');

        }
      })
    },
    tabNavigation: function() {
      let maxHeight = 0;

      function setTabBodyHeight() {
        $('.tab-body').each(function(){
          let activeTabContent = $(this).find('.tab-content.active');
          if(activeTabContent.length > 0) {
            let tabBodyPaddingTop = parseInt($(this).css('padding-top'));
            let newHeight = activeTabContent.outerHeight() + tabBodyPaddingTop;
            $(this).css('height', newHeight+'px');
          } else {
            let currentTabBodyHeight = $(this).outerHeight(); 
            $(this).css('height', currentTabBodyHeight+'px');
          }
        });
      }

      setTabBodyHeight();

      // Recalculate on window resize
      $(window).on('resize', function() {
        setTabBodyHeight();
      });

      function syncTabNavigationButtonStates(scope = document) {
        $(scope).find('.tab-navigation label.button').each(function() {
          $(this).toggleClass('no-hover', $(this).hasClass('active'));
        });
      }
      
      $('.tab-navigation label.active').each(function(){
          let indicatorOffset = $(this).position().left;
          let indicator = $(this).parent().find(".indicator");
          let labelWidth = $(this).outerWidth();
          if(indicator.length > 0) {
              indicator.css({"left":indicatorOffset+'px', 'width':labelWidth+'px'});

          }

      });
    syncTabNavigationButtonStates();

      $('.tab-navigation label, .tab-navigation a').on('click touch', function(){
          let tabNavID = $(this).data('tab');
          $('.tab-navigation label, .tab-navigation a').removeClass('active');
          $(this).addClass('active');
      syncTabNavigationButtonStates();
          let activeIndex = $(this).index();
          let maxHeight = 0;

          let indicatorOffset = $(this).position().left;
          let indicator = $(this).parent().find(".indicator");
          let labelWidth = $(this).outerWidth();
          if(indicator.length > 0) {
              indicator.css({"left":indicatorOffset+'px', 'width':labelWidth+'px'});

          }

          $('.tab-content').each(function(){
            
          
            let tabID = $(this).attr('id');
            let currentTab = $(this);
            let primaryDelay = 350;
            let secondaryDelay = 150;
            if($(window).outerWidth() < 992) {
                primaryDelay = 350;
                secondaryDelay = 150;
            }
            
            if(tabID.toString() === tabNavID.toString()) {
          
              let tabBodyPaddingTop = parseInt($(this).parents('.tab-body').css('padding-top'));
              

              let newHeight = currentTab.outerHeight() + tabBodyPaddingTop;
             
              currentTab.addClass('display');

              app.initSwipers();
               $(this).parents('.tab-body').css('height', newHeight+'px');
              setTimeout(function(){
                currentTab.removeClass('inactive');
                currentTab.addClass('active');
                
                // Smooth scroll to the active tab content
                // let headerHeight = $('header#header').outerHeight();
                // let scrollTarget = currentTab.offset().top - headerHeight;
                
                // $('html, body').animate({
                //   scrollTop: scrollTarget
                // }, 1000);
              }, primaryDelay);

            } else {
              
              currentTab.removeClass('active');

              setTimeout(function(){
                currentTab.addClass('inactive');
              }, secondaryDelay);

              setTimeout(function(){
                currentTab.removeClass('display');
              }, primaryDelay);
            }
          });

          if($(window).outerWidth() < 992) {
            //animate to top

            let offsetTarget = $(this).parents('.building-row');
            

            $('html, body').animate({
                scrollTop: offsetTarget.offset().top - 95
            }, 500);


          }

      });


      let windowLocation = window.location.hash;
      
      if(windowLocation != '') {
        
        windowLocation = windowLocation.substring(1);
       

      

        $('.tab-navigation label').each(function(){
          let tabNavID = $(this).data('tab');
          if(tabNavID === windowLocation) {
            $(this).addClass('active');
            
          } else {
            $(this).removeClass('active');
          }

        });
        syncTabNavigationButtonStates();
        $('.tab-content').each(function(){
            
            
          let tabID = $(this).attr('id');
          

          if(tabID === windowLocation) {
            $(this).removeClass('inactive');
            $(this).addClass('active');
            $(this).addClass('display');
         
          } else {
            $(this).addClass('inactive');
            $(this).removeClass('active');
          }

        });
      } else {
        // No hash - activate first tab by default
        $('.tab-navigation').each(function(){
          if(!$(this).find('label.active, a.active').length) {
            $(this).find('label:first, a:first').addClass('active');
            syncTabNavigationButtonStates(this);
            let firstTabID = $(this).find('label:first, a:first').data('tab');
            $('.tab-content').each(function(){
              let tabID = $(this).attr('id');
              if(tabID === firstTabID) {
                $(this).removeClass('inactive').addClass('active display');
              } else {
                $(this).addClass('inactive').removeClass('active display');
              }
            });
          }
        });
      }




     

      

    },
    countDecimals: function (number) {
        
        let number_array = number.toString().split(".");
        

        if(Number(number) % 1 === 0) {
            return 0;
        } else {
            return number.toString().split(".")[1].length || 0; 
        }
        
        
    },
    
    numberCommaFormatting:function() {

      $('.loan-size').each(function(){
        let loan_size = $(this).text();
        loan_size = app.numberWithCommas(loan_size);
        loan_size = '$' + loan_size;
        $(this).text(loan_size);

      })
    },
   statFormatting: function() {


            $('p.stat .stat-number').each(function(){

                const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);

                let stat_val = parseFloat($(this).data('end-point'));

            //     console.log('Data attr end point:' + $(this).data('end-point'));
            //    console.log(stat_val);
                

                if(isNumeric(stat_val)) {
                    // console.log('stat_val: '+stat_val);
                    $(this).text(stat_val);

                    let decimal = app.countDecimals(stat_val);

                    $(this).attr('data-end-point', stat_val);
                    
                    let animElemWidth = $(this).outerWidth();
                    $(this).css('min-width', animElemWidth+'px');

                    // console.log($(this));


                    app.newCountUp($(this), stat_val, decimal);
                    ///trigger count up - that'l add the commas

                } 


            });


        },
        newCountUp: function(elem, number, decimal) {


            // console.log(elem);
            // console.log(number);
            // console.log(decimal);

            
            let options;


            if(decimal) {
                options = {
                    enableScrollSpy: true,
                    duration:3,
                    decimalPlaces: 1,
                };
            } else {
                options = {
                    enableScrollSpy: true,
                    duration:3,
                };
            }

            

            let countUp = new CountUp($(elem)[0], number, options);


            

        },
    heroOffsetCalc: function() {

        $('.offset-to-hero').each(function(){
            let offsetBlock = $(this);

            let localHero = offsetBlock.parents('.building-row').find('.building-block.hero');
             let localHeroContent = localHero.find('.hero-content.secondary');
             if(localHeroContent.length > 0) {

             
            let localHeroContentHeight = localHeroContent.position().top;

            

            if($(window).outerWidth() > 992) {
                offsetBlock.css('padding-top', localHeroContentHeight+'px');
                
            } else {
                offsetBlock.css('padding-top', localHeroContentHeight+10+'px');
                if($('body').hasClass('archive')) {
                  let title_height = localHero.find('.hero-content h1').outerHeight();
                //   let title_height = localHero.find('.hero-content h1').outerHeight();
                  
                  offsetBlock.css('padding-top', localHeroContentHeight + title_height  - 55 + 'px'); //-55 accounts for padding under title + a lil extra


                }
            }
          }
             

            
        });

    },
    timeLinePrep: function(){



        $('.building-block.timeline').each(function(){

            let parentBlock = $(this);

            let initialYearPos = parentBlock.find('.content-container-parent .timeline-year').position().top;

            parentBlock.find('.timeline-container').css('padding-top', initialYearPos+108+'px'); ///108 is a mystery, no idea why but this gets the pos sticky years lining up with the left year



        });





    },
    affixElemPrep:function(st, lastScrollTop) {
      $(".affix-anchor").each(function () {

        let elem = $(this).data("elem");


            elem = $("#" + elem);
        
            ////RECORD WIDTH OF ELEM TO AFFIX TO MAINTAIN WHEN POS FIXED APPLIED
            let trueElemWidth = elem.outerWidth();
            let affixToNav = $(this).data('affix-to-nav');

            ////RECORD TRUE LEFT OFFSET TO RE-APPLY WHEN POS FIXED APPLIED
            let trueElemLeftOffset = elem.offset().left; 
            
            ////RECORD HEIGHT OF HEADER TO OFFSET SCROLL ANIMATION
            let headerHeight = $("#header").outerHeight();
            

            ////OFFSET OF AFFIX ANCHOR - HEADER HEIGHT TO AFFIX ELEMTS WEHEN THEY HIT BOTTOM OF HEADER
            let anchorOffset = $(this).offset().top - headerHeight;
            let timeline = $(this).data('timeline');
        

            if($(this).data('ignore-offset')) {
                anchorOffset = 0;
            }

            let winHeight = $(window).outerHeight();
            

            let offsetElem = $(this).data("offset-elem");
            let offsetElemID = $(this).data("offset-elem");
            offsetElem = document.getElementById(offsetElem);

            let affixElem = $(this).data("affix-elem");
            affixElem = document.getElementById(affixElem);
            let unaffixElem = $(this).data("unaffix-elem");
            unaffixElem = document.getElementById(unaffixElem);
            let affixOnEntry = $(this).data("affix-on-entry");
            let affixToMidPoint = $(this).data("affix-to-mid-point");
            let affixElemOffset = affixElem.offsetTop + affixElem.offsetHeight;
            let affixValue = affixElemOffset;
            if (offsetElem) {
                affixValue = offsetElem.offsetTop + offsetElem.offsetHeight;
            }
            let unaffixElemOffset = winHeight;
            let hitsBottomOfScreen = winHeight;
            let elemOffset = (winHeight - elem.outerHeight());
            let affixTopValue = headerHeight;
            ////minus-ing header height here to account for fixed header padding added to first row
            let unaffixTopValue = $(affixElem).outerHeight() - elem.outerHeight() - headerHeight;
            if(elem.parents('.building-row').length > 0 && !affixToNav) {
                //element is a block level or lower
                //setting hitsBottomOfScreen to 0 will unnaffix when unnaffix elem hits bottom of internal elem (as opposed to bottom of screen)
                hitsBottomOfScreen = (elem.outerHeight());
                elemOffset = 0;
            }
            if(elem.parents('.building-block').length > 0 && !affixToNav) {
                affixTopValue = elem.offset().top;
            }
            if(elem.parent('.building-block').length > 0) {

                 trueElemWidth = elem.parent('.building-block').outerWidth();

            }

            if (unaffixElem) {
                unaffixElemOffset = unaffixElem.offsetTop - hitsBottomOfScreen + elemOffset; 
                // FINDS WHEN UNAFFIX ELEM HITS BOTTOM OF AFFIXED ELEM (unaffixElem.offsetTop - winHeight : hits bottom of window, (winHeight - elem.outerHeight()) : finds gap from elem to bottom of window) (as an scroll top equivalent)
               
                //ONLY USE IF FIXED HEADER
                unaffixElemOffset = unaffixElemOffset;
                unaffixTopValue = unaffixTopValue;
            }




            if(timeline) {
                unaffixElemOffset = unaffixElem.offsetTop - hitsBottomOfScreen + elemOffset + 31.5; 
                unaffixElemOffset = unaffixElemOffset;
            }
        
            if(affixToNav) {
                if($(window).outerWidth() >= 992) {
                    affixTopValue = 0;
                    affixElemOffset = 0;
                    anchorOffset = $(this).offset().top;
                    affixValue = affixElemOffset;
                } else {
                    ////ON MOBILE NAV LEVEL AFFIX HAPPENS JUST BELLOW NAV TRIGGER ITEMS
                    affixTopValue = $('.header-toggle-container').offset().top + $('.header-toggle-container').outerHeight() + 10;
                    affixElemOffset = $('.header-toggle-container').offset().top + $('.header-toggle-container').outerHeight() + 10;
                    anchorOffset = $(this).offset().top - affixElemOffset;
                    affixValue = affixElemOffset;
                }
            }
            if(affixToMidPoint) {
                if($(window).outerWidth() >= 992) {
                    // affixTopValue = 0;
                    // affixElemOffset = 0;

                    anchorOffset = $(this).offset().top - (winHeight/2);

                    affixValue = winHeight/2;
                }


            }

            if(affixOnEntry) {
              anchorOffset = (anchorOffset - winHeight) + (headerHeight * 2);
              ///unnaffix when unaffix elem hits bottom of screen
              unaffixElemOffset = unaffixElemOffset - winHeight;

              hitsBottomOfScreen = 0;
            }
            $(this).data('unaffix-top-value', unaffixTopValue);

            $(this).data('elem-width', trueElemWidth);
            $(this).data('elem-left-offset', trueElemLeftOffset);
            $(this).data('elem-top-offset', anchorOffset);

            $(this).data('affix-elem-offset', affixElemOffset);

            $(this).data('anchor-offset', anchorOffset);
            $(this).data('hits-bottom-of-screen', hitsBottomOfScreen);
            $(this).data('elem-offset', elemOffset);
            $(this).data('affix-value', affixValue);
            $(this).data('unaffix-elem-offset', unaffixElemOffset);

            $(this).data('affix-top-value', affixTopValue);

      });
    },
    affixElemOnScroll: function (st, lastScrollTop) {
            let siteFooter = $("footer#footer");

            if (siteFooter === undefined || !siteFooter) {
                siteFooter = $("footer#footer");
            }

            $(".affix-anchor").each(function () {

                
                let trueElemWidth = $(this).data('elem-width');

                let trueElemLeftOffset = $(this).data('elem-left-offset'); 

                let anchorOffset = $(this).data('anchor-offset');

                let elem = $(this).data("elem");


                elem = $("#" + elem);

                let offsetElem = $(this).data("offset-elem");
                
             

                let affixElem = $(this).data("affix-elem");
  
                if (
                    affixElem === "" ||
                    affixElem === undefined ||
                    affixElem === null
                ) {
                    affixElem = "header";
                }
                affixElem = document.getElementById(affixElem);

                let unaffixElem = $(this).data("unaffix-elem");

                if (unaffixElem) {
                    unaffixElem = document.getElementById(unaffixElem);
                }

                let affixElemOffset = $(this).data('affix-elem-offset');
                
                let affixValue = affixElemOffset;

                if (offsetElem) {
                    affixValue = $(this).data('affix-value');
                    
                }

              
                let unaffixElemOffset = $(this).data('unaffix-elem-offset');

                //ONLY USE IF FIXED HEADER
              
            
                let unaffixTopValue = $(this).data('unaffix-top-value'); 


                let affixTopValue = $(this).data('affix-top-value');


                let affixOnEntry = $(this).data("affix-on-entry");
        
                if ($(this).data("unaffix-mobile")) {
                    //dont afix mob
                    if ($(window).outerWidth() > 992) {


                        app.actualAffixer(
                            elem,
                            affixElemOffset,
                            unaffixElemOffset,
                            unaffixTopValue,
                            affixTopValue,
                            anchorOffset,
                            st,
                            lastScrollTop,
                            trueElemWidth,
                            trueElemLeftOffset
                        );



                    }
                } else {
                    //afix mob
                    
                    app.actualAffixer(
                        elem,
                        affixElemOffset,
                        unaffixElemOffset,
                        unaffixTopValue,
                        affixTopValue,
                        anchorOffset,
                        st,
                        lastScrollTop,
                        trueElemWidth,
                        trueElemLeftOffset
                    );
                }
            });
        },

        actualAffixer: function (
            elem,
            affixElemOffset,
            unaffixElemOffset,
            unaffixTopValue,
            affixTopValue,
            anchorOffset,
            st,
            lastScrollTop,
            trueElemWidth,
            trueElemLeftOffset
        ) {
            let affixElemBool = affixElemOffset - anchorOffset;

            

            if (affixElemBool < 0) {
                affixElemBool = affixElemBool * -1;
            }

            let headerHeight = $("#header").outerHeight();
            if (
                st > lastScrollTop &&
                st >= anchorOffset &&
                st < unaffixElemOffset
            ) {
                if (!elem.hasClass("affix")) {
                    let affixElemHeight = elem.outerHeight();

                    if (elem.hasClass("hero")) {
                        elem.css("max-height", affixElemHeight);
                    }

                    if (elem.next() === undefined) {
                        elem.parent().css("height", affixElemHeight);
                    }

                    let origElemWidth = elem.outerWidth();

                    elem.css("max-width", trueElemWidth + "px");
                    elem.css("left", trueElemLeftOffset + "px");
                    elem.addClass("affix");
                    elem.removeClass("unaffix");
                    elem.css("top", affixTopValue + "px"); // old var affixValuePx
                    elem.css("bottom", "auto");
                }
            } else if (
                st > lastScrollTop &&
                st >= anchorOffset &&
                st > unaffixElemOffset
            ) {
                elem.css("max-width", "unset");
                 elem.css("left", "unset");
                elem.removeClass("affix");
                elem.addClass("unaffix");
                elem.css("top", unaffixTopValue+"px"); // old var affixValuePx
                elem.css("bottom", "auto");
            } else if (
                st < lastScrollTop &&
                st >= anchorOffset &&
                st < unaffixElemOffset
            ) {
                let origElemWidth = elem.outerWidth();
                elem.css("max-width", trueElemWidth + "px");
                elem.css("left", trueElemLeftOffset + "px");
                elem.addClass("affix");
                elem.removeClass("unaffix");
                elem.css("top", affixTopValue + "px"); // old var affixValuePx
                elem.css("bottom", "auto");
            } else if (st < lastScrollTop && st < anchorOffset) {
                //scrolling up, st is less than affix point
                if (elem.next() === undefined) {
                    elem.parent().css("height", "auto");
                }
                elem.css("left", "unset");
                elem.css("max-width", "unset");
                elem.removeClass("affix");
                elem.removeClass("unaffix");
                if (elem.hasClass("hero")) {
                    elem.css("max-height", "unset");
                }
                elem.css("top", "auto");
            }
        },
   
    
    

    affixWidthReset:function() {
      $('.affix').each(function(){
        $(this).removeClass('affix');
        $(this).removeClass('unaffix');
        $(this).css('max-width', 'unset');
        $(this).css('left', 'auto');
        
        $(this).css('max-width', $(this).outerWidth() + 'px');
        $(this).css('left', $(this).offset().left+'px');
        $(this).removeClass('affix');

      })
      
    },

    initServiceWorker: function() { 
      

        const worker = new Worker();


        
        worker.postMessage({ command: 'start' });

        worker.onmessage = function(e) {


          
        };

              
        function cancelWorker() {
            worker.postMessage({ command: 'stop'});
        }

    },
   
    expertPerspectivesAjaxArticles: function(){

      $(document).on('click', '#team-selector-container .card.post.team', function(){
          let team_member_id = $(this).data('team-member-id');

          $.ajax({ // you can also use $.post here

          url: ajax_object.ajax_url, // AJAX handler
          data: {
              'action': 'expert_perspectives',
              'team_member_id': team_member_id,
              
          },
          type: 'POST',
          dataType:'json',
          beforeSend: function (xhr) {

          },
          success: function (res) {
            if (res) {
              if(res.html != null) {
                 
                  $('#posts-container-experts').html(res.html) // insert new posts
              } 
          
            }
          },
          error: function(xhr, status, error) {
            var err = eval("(" + xhr.responseText + ")");
            alert(err.Message);
          }
        })





      });



    },

    stickyHeroHide: function(st) {
      let footerScrollBool = $(window).outerHeight();
      
      if (st > (footerScrollBool + 150) && $(window).outerWidth() < 992) {
        $('#hero.building-row.sticky').addClass('hide');
      } else {
        $('#hero.building-row.sticky').removeClass('hide');
      }
    },

    initLoaded: function() {
      

      let loaderTimeIn = 350;

          
      setTimeout(function(){
        
        // app.initSwipers();
        $('body').addClass('loaded');

        if(window.location.hash) {
          let target = window.location.hash;
          target = target.substring(1);
          app.scrollTo(target);
        }
      }, loaderTimeIn);

    }
  };


  let windowHeight = $(window).outerHeight();
  let lastScrollTop = 0;
  let affixNavLastScrollTop = 0;
  let st = $(this).scrollTop() ? $(this).scrollTop() : 1;
  let swiperCollection = []; // Store all swiper instances
  let logoTickerSwiper = null; // Store logo ticker swiper

  document.addEventListener("DOMContentLoaded", function() {
    //app.set100vh();

    // Handle anchor link scrolling with delay
    if(window.location.hash) {
      const hash = window.location.hash.substring(1);
      // Prevent default browser jump
      if(history.pushState) {
        history.pushState('', document.title, window.location.pathname + window.location.search);
      } else {
        window.location.hash = '';
      }
      
      // Wait for page to fully load, then scroll to anchor
      setTimeout(function() {
        app.scrollTo(hash);
      }, 500);
    }

    // Header CTA scroll to contact section if on contact page
    $('.header-cta').on('click', function(e) {
      const href = $(this).attr('href');
      // Check if we're on the contact page and the link goes to contact page
      if(window.location.pathname.includes('/contact') && href && href.includes('/contact')) {
        e.preventDefault();
        if($('#contact-grids').length) {
          app.scrollTo('contact-grids');
        }
      }
    });

    app.affixNavigation(st, lastScrollTop);

    if($(window).outerWidth() > 992) {
        app.lenisSmoothScrollInit();
    }
    

    
    app.onReady();
    app.inView();
    app.revealSlideOutTabs();

    app.closeModal();
    app.expandCardContent();


    app.initAccordions();
    app.initSwipers();
    app.initLogoTickerSwiper();
    app.initSelects();
    app.statFormatting();

     app.heroOffsetCalc();
    app.affixElemPrep();
    
    app.affixElemOnScroll(st, lastScrollTop);
    


    app.initModals();
    
    app.tabNavigation();


    app.initFilter();
    app.initLoadMore();
    app.initPagination();
  
    app.toggleCardContent();
    app.gridSlideAnimate();

    app.equaliseCardTitles();

    // Titles are measured in the current font, so re-run once webfonts swap in
    // and the line count can change.
    if(document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function(){
        app.equaliseCardTitles();
      });
    }

    app.initLoaded();
    
    
  });

  // Track previous window width to detect breakpoint changes for team accordions

  let previousWidth = $(window).width();
  let previousLayout = 'desktop'; // Track which layout we're in
  
  // Function to determine current layout
  function getCurrentLayout() {
    let width = $(window).width();
    if(width <= 991) return 'mobile';
    return 'desktop';
  }
  
  previousLayout = getCurrentLayout();

  $(window).resize(function(){

    st = $(window).scrollTop();
    lastScrollTop = st;
    
   
    app.heroOffsetCalc();

    app.affixElemOnScroll(st, lastScrollTop);

    // Reinitialize all swipers on resize
    app.initSwipers();
    app.initLogoTickerSwiper();

    // Titles rewrap at different widths, so re-measure after the swipers rebuild.
    app.equaliseCardTitles();


   

    // USED ON TEAM ACCORDIONS
    // Check if layout breakpoint has changed
    let currentLayout = getCurrentLayout();
    
    if(currentLayout !== previousLayout) {
      // Layout changed - close all expandable content
      $('.expandable--content').css('max-height', '0px');
      $('.expandable--content').removeClass('active');
      $('.team-members .card').removeClass('active');
      previousLayout = currentLayout;
    } else {
      // Same layout - just recalculate expandable content height if active
      $('.expandable--content.active').each(function() {
        let newContentHeight = $(this).find('.expandable--content-inner').outerHeight();
        $(this).css('max-height', newContentHeight + 'px');
      });
    }

  });

  

  $(window).scroll(function (event) {
    st = $(this).scrollTop();
   
    // app.drawSvgMaskOnScroll(st, lastScrollTop);
    app.affixNavigation(st, lastScrollTop);
    app.affixElemOnScroll(st, lastScrollTop);
    app.tabNavScrollActivate(st);
    app.stickyHeroHide(st);

    lastScrollTop = st;
  });

})(jQuery);